import {useSelect} from '@wordpress/data';
import {CONFIG} from '../../../globals/config';
import type {ReactElement} from 'react';

type Props = {
	children: () => ReactElement;
};

/**
 * Higher order component which only renders children if the current post type:
 * - Supports custom fields.
 * - Is included in the `CONFIG.postTypes` object.
 *
 * If custom-fields is not supported, the `meta` key is not included in the REST API.
 * `usePostMeta` will not work without this key.
 *
 * @since 9.5.8
 *
 * @ticket #13259
 */
const Allowed = ( {children}: Props ) => {
	const postType = useSelect( select => {
		const current = select( 'core/editor' )?.getCurrentPostType();
		if ( null === current || ! Object.keys( CONFIG.postTypes ).includes( current ) ) {
			return null;
		}
		return current;
	}, [] );

	const allowed = useSelect( select => {
		if ( null === postType ) {
			return false;
		}
		const type = select( 'core' ).getPostType( postType );
		if ( 'undefined' === typeof type ) {
			return false;
		}
		return true === type.supports?.[ 'custom-fields' ];
	}, [ postType ] );

	return allowed ? children() : null;
};

export default Allowed;
